<template>
  <section class="empty">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h4 class="text-center">{{ $t("Empty.noItems") }}</h4>
          <br />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h6 v-if="error" class="text-center alert alert-warning">
            {{ $t("Empty.addItem.error") }}
          </h6>
          <fieldset>
            <div class="input-group" style="width: 100%">
              <label for="newItemnumber" />
              <input
                type="text"
                v-model="newItemnumber"
                id="newItemnumber"
                style="height: 2em; width: 100%; margin-bottom: 2rem"
                class="form-control"
                @keyup.enter="addItem"
                :placeholder="$t('Empty.addItem.placeholder')"
              />
              <button class="btn btn-primary" type="button" @click="addItem">
                {{ $t("Empty.addItem.button") }}
              </button>
              <button class="btn btn-secondary" @click="toggleWishlist()">
                {{ $t("Empty.openWishlist") }}
              </button>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SetData from "@/vuex/SetData";
import Config from "@/vuex/Config";
import Logger from "@/assets/Helper/Logger";
import Validate from "@/assets/Helper/Validate";
import Warehouse from "@/assets/DAO/Warehouse";

export default {
  name: "Empty",
  components: {},
  props: {},
  data() {
    return {
      newItemnumber: "",
      error: false,
    };
  },
  methods: {
    addItem: function () {
      this.newItemnumber = this.newItemnumber.trim();

      this.error = false;

      if (Validate.isSet(this.newItemnumber)) {
        window.location.href =
          Config.getters.getIntegrationUrlPrafix + "/?#" + this.newItemnumber;
      } else if (
        Validate.isWarehouse(this.newItemnumber) &&
        Config.getters.isShopLoginActive
      ) {
        SetData.dispatch("clearItems", true)
          .then(() => {
            Warehouse.get(this.newItemnumber, Config.getters.getActiveShop);
          })
          .catch((error) => {
            Logger.error(error);
          });
      } else if (Validate.isItemnumber(this.newItemnumber)) {
        window.location.href =
          Config.getters.getIntegrationUrlPrafix +
          "/" +
          this.newItemnumber +
          "/";
      } else {
        this.error = true;
      }
    },
    toggleWishlist: function () {
      this.$root.$emit("wishlist");
      Config.dispatch("setVisualMode", "wishlist");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app section.empty {
  margin-top: 4em;
  padding-bottom: 8em;

  .btn-primary,
  .btn-secondary {
    width: calc(50% - 0.75rem);

    @media (min-width: 768px) {
      width: fit-content;
    }
  }

  .btn-secondary {
    margin-left: 0.75rem;
  }

  .container {
    padding: 1em;

    .row {
      padding-bottom: 4rem;
    }
  }
}
</style>
